'use client';

import clsx from 'clsx';

import styles from './Switch.module.scss';

type SwitchProps = {
    value: boolean;
    onChange?: (value: boolean) => void;
    disabled?: boolean;
};

export const Switch: React.FC<SwitchProps> = ({ value, onChange, disabled }) => (
    <div
        className={clsx(styles.root, { [styles.checked]: value, [styles.disabled]: disabled })}
        onClick={() => onChange(!value)}
    >
        <div className={styles.switchToggleThumb}></div>
    </div>
);
